import React from 'react'
import { useTheme } from '../../hooks/useTheme'
import ModalButton from './ModalButton'

interface ConfirmDeleteModalProps {
  isOpen: boolean
  title?: string
  message?: string
  itemName?: string
  onConfirm: () => void | Promise<void>
  onCancel: () => void
  isLoading?: boolean
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  isOpen,
  title = '¿Eliminar elemento?',
  message = '¿Estás seguro que deseas eliminar este elemento?',
  itemName,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  const { colors } = useTheme()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-sm w-full">
        {/* Header */}
        <div
          className="px-6 py-4 text-white"
          style={{ backgroundColor: colors.error }}
        >
          <h2 className="text-lg font-bold">⚠️ {title}</h2>
        </div>

        {/* Body */}
        <div className="px-6 py-6 space-y-4">
          <p className="text-gray-700 text-sm leading-relaxed">
            {message}
          </p>
          {itemName && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-sm">
                <span className="font-semibold text-gray-700">Elemento: </span>
                <span className="text-gray-900 font-medium break-words">{itemName}</span>
              </p>
            </div>
          )}
          <p className="text-xs text-gray-500 italic">
            Esta acción no puede ser deshesha.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3 rounded-b-lg">
          <ModalButton
            variant="secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancelar
          </ModalButton>
          <ModalButton
            variant="danger"
            onClick={onConfirm}
            loading={isLoading}
            disabled={isLoading}
          >
            {isLoading ? 'Eliminando...' : 'Sí, eliminar'}
          </ModalButton>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDeleteModal
